import React from 'react';
import * as yup from 'yup';
import {Formik, Form, Field} from 'formik';
import {TextField} from 'formik-material-ui';

import {Button} from '@material-ui/core';

const initialValues = {
    password: '',
    password2: '',
};

const validationSchema = yup.object().shape({
    password: yup.string().min(6).required(),
    password2: yup
        .string()
        .oneOf([yup.ref('password'), null], "Passwords don't match"),
});

export default function PasswordAdd({submitLabel, onSubmit}) {
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
        >
            {({touched, values, errors}) => (
                <Form>
                    <Field
                        component={TextField}
                        type='password'
                        label='Password'
                        name='password'
                        fullWidth
                    />
                    <Field
                        component={TextField}
                        type='password'
                        label='Password (again)'
                        name='password2'
                        fullWidth
                    />
                    <Button type='submit' variant='contained' color='primary'>
                        Add a password
                    </Button>
                </Form>
            )}
        </Formik>
    );
}
